import { render, staticRenderFns } from "./SelectYesOrNo.vue?vue&type=template&id=24ee76e4&scoped=true&"
import script from "./SelectYesOrNo.vue?vue&type=script&lang=ts&"
export * from "./SelectYesOrNo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ee76e4",
  null
  
)

export default component.exports